import React from "react";
import { FaArrowTrendUp, FaCodeBranch, FaLayerGroup } from "react-icons/fa6";

const batches = [
  {
    name: "Beginner Batch",
    level: "Starter",
    members: "50+",
    description: "Build fundamentals with structured guidance and frequent practice.",
    skills: ["Programming basics", "Simple algorithms", "Logic building"],
    icon: FaLayerGroup,
  },
  {
    name: "Intermediate Batch",
    level: "Developing",
    members: 16,
    description: "Strengthen data structures and improve problem-solving speed.",
    skills: ["Data structures", "Algorithm patterns", "Complexity analysis"],
    icon: FaCodeBranch,
  },
  {
    name: "Advanced Batch",
    level: "Expert",
    members: 10,
    description: "Train for national contests with optimization and strategy.",
    skills: ["Advanced algorithms", "Contest strategy", "Optimization"],
    icon: FaArrowTrendUp,
  },
];

const BatchesPage = () => {
  return (
    <section className="home-section">
      <div className="home-container">
        <div className="mb-8 flex flex-wrap items-end justify-between gap-3">
          <div>
            <span className="section-kicker">Learning Tracks</span>
            <h2 className="home-title mt-4 text-2xl font-bold sm:text-4xl">
              From fundamentals to <span className="home-accent-gradient">contest readiness</span>
            </h2>
          </div>
          <p className="max-w-md text-sm home-muted">
            Members move through clearly designed stages based on performance, consistency, and readiness.
          </p>
        </div>

        <div className="grid home-stagger-grid gap-4 lg:grid-cols-3">
          {batches.map((batch) => (
            <article key={batch.name} className="home-card relative overflow-hidden p-6">
              <div
                className="absolute -right-8 -top-8 z-0 h-24 w-24 rounded-full"
                style={{ background: "color-mix(in srgb, var(--brand-soft) 70%, transparent)" }}
              />

              <div className="relative z-10 mb-4 flex items-start justify-between gap-3">
                <div>
                  <h3 className="text-xl font-semibold">{batch.name}</h3>
                  <p className="text-sm home-muted">{batch.level} level</p>
                </div>
                <div className="home-pill relative z-20 inline-flex items-center gap-2 px-3 py-1 text-xs font-semibold">
                  <batch.icon className="home-accent" /> {batch.members}
                </div>
              </div>

              <p className="relative z-10 text-sm leading-7 home-muted">{batch.description}</p>

              <ul className="relative z-10 mt-5 space-y-2 text-sm">
                {batch.skills.map((skill) => (
                  <li key={skill} className="home-card-strong px-3 py-2">
                    <span className="home-accent mr-2">•</span>
                    {skill}
                  </li>
                ))}
              </ul>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BatchesPage;
